// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2t1YL","gfeWrapper":"CalendarEvent_gfeWrapper__3LIsY"};